module.exports = __webpack_public_path__ + "static/media/blog3.d1a9ad4d.png";